/** @format */

import React from 'react'
import { Select, Option, Checkbox, Icon, TableColumn, Table, Button } from '@king-design/react'
import request from 'src/utils/request'
import API from 'src/api/ApiContacts'
import { useAsync } from 'react-use'
import { cloneDeep } from 'lodash'
export interface ConcatProps {
  ContactID: string
  ContactName?: string
  ContactFlag: number
  ContactWay: number
}
interface AlarmReciverProps {
  value?: ConcatProps[]
  onChange?: (data: ConcatProps[]) => void
  maxLength?: number
  style?: React.CSSProperties
}

const AlarmReciver: React.FC<AlarmReciverProps> = ({
  value = [],
  onChange,
  maxLength = 10,
  style
}) => {
  const { value: result } = useAsync(async () => {
    const { data: userlist } = await request(API.getAlertUser, {
      method: 'get',
      data: {
        PageIndex: 1,
        Cap: 1
      }
    })
    const { data: grouplist } = await request(API.getUserGroup, {
      method: 'get',
      data: {
        PageIndex: 1,
        Cap: 1
      }
    })
    return {
      userlist: userlist?.userlist || [],
      grouplist: grouplist?.usergrplist || []
    }
  }, [])

  const onTableChange = (data, index) => {
    const clone = cloneDeep(value)
    clone[index] = { ...clone[index], ...data }
    onChange && onChange(clone)
  }

  return (
    <div className="alarm_reciver" style={style || {}}>
      <Table data={value || []} rowKey={data => data.ContactID} checkType="none">
        <TableColumn
          key="ContactName"
          title="接收人"
          slotTemplate={([data, index]) => {
            return (
              <Select
                filterable
                container={() => document.getElementsByClassName('alarm_reciver')[0]}
                value={data.ContactID}
                onChangeValue={value => {
                  onTableChange({ ContactID: value }, index)
                }}
              >
                {/* 1=联系组 2=联系人 */}
                {data.ContactFlag === 1
                  ? result?.grouplist?.map(opt => {
                      const disabled = value.find(
                        item => item.ContactFlag === 1 && item.ContactID === opt.usrgrpid
                      )
                      return (
                        <Option disabled={!!disabled} key={opt.usrgrpid} value={opt.usrgrpid}>
                          {opt.name}
                        </Option>
                      )
                    })
                  : null}
                {data.ContactFlag === 2
                  ? result?.userlist?.map(opt => {
                      const disabled = value.find(
                        item => item.ContactFlag === 2 && item.ContactID === opt.userid
                      )
                      return (
                        <Option disabled={!!disabled} key={opt.userid} value={opt.userid}>
                          {opt.name}
                        </Option>
                      )
                    })
                  : null}
              </Select>
            )
          }}
        />
        <TableColumn
          width="30%"
          key="ContactWay"
          title="通知方式"
          slotTemplate={([data, index]) => {
            return (
              <>
                <Checkbox
                  style={{ marginRight: '8px' }}
                  value={data.ContactWay === 1 || data.ContactWay === 3 ? true : false}
                  onChangeValue={val => {
                    const newData = cloneDeep(value)
                    const currentWay = newData[index].ContactWay
                    if ((currentWay === 1 || currentWay === 2) && val === true) {
                      newData[index].ContactWay = 3
                    } else if (currentWay === 0) {
                      newData[index].ContactWay = 1
                    } else if (currentWay === 3) {
                      newData[index].ContactWay = 2
                    } else {
                      newData[index].ContactWay = 0
                    }
                    onChange(newData)
                  }}
                >
                  邮箱
                </Checkbox>
                <Checkbox
                  value={data.ContactWay === 2 || data.ContactWay === 3 ? true : false}
                  onChangeValue={val => {
                    const newData = cloneDeep(value)
                    const currentWay = newData[index].ContactWay
                    if ((currentWay === 1 || currentWay === 2) && val === true) {
                      newData[index].ContactWay = 3
                    } else if (currentWay === 0) {
                      newData[index].ContactWay = 2
                    } else if (currentWay === 3) {
                      newData[index].ContactWay = 1
                    } else {
                      newData[index].ContactWay = 0
                    }
                    onChange(newData)
                  }}
                >
                  短信
                </Checkbox>
              </>
            )
          }}
        />
        <TableColumn
          key="operate"
          title="操作"
          width="80"
          slotTemplate={([data, index]) => {
            return (
              <a
                onClick={() => {
                  const clone = cloneDeep(value)
                  clone.splice(index, 1)
                  onChange && onChange(clone)
                }}
              >
                删除
              </a>
            )
          }}
        ></TableColumn>
      </Table>

      <p style={{ margin: 0, lineHeight: '32px' }}>
        <Button
          disabled={value.length >= maxLength}
          type="link"
          onClick={() => {
            onChange([
              ...value,
              {
                ContactID: '',
                ContactName: '',
                ContactFlag: 1,
                ContactWay: 3
              }
            ])
          }}
        >
          <Icon color="#0091ea" className="ion-plus-round" />
          添加联系组
        </Button>

        <Button
          disabled={value.length >= maxLength}
          type="link"
          onClick={() => {
            onChange([
              ...value,
              {
                ContactID: '',
                ContactName: '',
                ContactFlag: 2,
                ContactWay: 3
              }
            ])
          }}
        >
          <Icon color="#0091ea" className="ion-plus-round" />
          添加联系人
        </Button>
      </p>
    </div>
  )
}

export default AlarmReciver
